export default "__VITE_ASSET__0801d3aa__"